import "./profile.css";
import ITskills from "../CandProfCreation/CandidateProfileSlice/ITskills/ITskills";
import JobPreferences from "../CandProfCreation/CandidateProfileSlice/JobPreference/JobPreferences";
import CandidateProfile from "../CandProfCreation/CandidateProfileSlice/AboutYou/CandidateProfile";
import Language from "../CandProfCreation/components/Language";
import EducationshowPage from "../candidateDashboard/components/EducationShow";
import ExperienceShowTesting from "../candidateDashboard/components/ExperienceShowTesting";
import Certifications from "../CandProfCreation/CandidateProfileSlice/Certifications/Certifications";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import JobPreferences2 from "../CandProfCreation/CandidateProfileSlice/JobPreference/JobPref2";
import Projects from "../CandProfCreation/CandidateProfileSlice/Project/Projects";
import CandidateActiveSubscription from "../candidateDashboard/components/CandidateActiveSubscription";

// Import Heroicons v2
import {
  CreditCardIcon,
  UserIcon,
  AcademicCapIcon,
  BriefcaseIcon,
  DocumentCheckIcon,
  CodeBracketIcon,
  CpuChipIcon,
  LanguageIcon,
  BriefcaseIcon as JobPrefIcon
} from '@heroicons/react/24/outline';

export function BasicDetails() {
  const dispatch = useDispatch();
  const [activeSection, setActiveSection] = useState('subscription');

  // Create refs for each section
  const subscriptionRef = useRef(null);
  const profileRef = useRef(null);
  const educationRef = useRef(null);
  const experienceRef = useRef(null);
  const certificationRef = useRef(null);
  const projectsRef = useRef(null);
  const skillsRef = useRef(null);
  const languageRef = useRef(null);
  const jobPrefRef = useRef(null);

  // Section data with icons
  const sections = [
    // { id: 'subscription', name: 'Subscription', icon: CreditCardIcon, ref: subscriptionRef },
    { id: 'profile', name: 'Career Objective', icon: UserIcon, ref: profileRef },
    { id: 'education', name: 'Education', icon: AcademicCapIcon, ref: educationRef },
    { id: 'experience', name: 'Experience', icon: BriefcaseIcon, ref: experienceRef },
    { id: 'certification', name: 'Certifications', icon: DocumentCheckIcon, ref: certificationRef },
    { id: 'projects', name: 'Projects', icon: CodeBracketIcon, ref: projectsRef },
    { id: 'skills', name: 'IT Skills', icon: CpuChipIcon, ref: skillsRef },
    { id: 'language', name: 'Languages', icon: LanguageIcon, ref: languageRef },
    { id: 'jobpref', name: 'Job Preferences', icon: JobPrefIcon, ref: jobPrefRef }
  ];

  // Scroll to section function
  const scrollToSection = (ref, id) => {
    window.scrollTo({
      top: ref.current.offsetTop - 20,
      behavior: "smooth"
    });
    setActiveSection(id);
  };

  // Track active section on scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;

      sections.forEach((section) => {
        if (section.ref.current && scrollPosition >= section.ref.current.offsetTop) {
          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  return (
    <div className="">
      <div style={{ fontFamily: "Inter, sans-serif" }}>
        <div className="py-12 min-h-screen bg-mainBg sm:px-6 sm:py-4">
          <div className="px-4 sm:px-0.5 relative">
            {/* Mobile Sidebar (Horizontal) - shown only on mobile */}
            <div className="hidden w-full bg-white sticky top-0 z-10 mb-4 overflow-x-auto">
              <div className="flex space-x-1 py-2 px-1">
                {sections.map((section) => (
                  <button
                    key={section.id}
                    onClick={() => scrollToSection(section.ref, section.id)}
                    className={`flex flex-col items-center justify-center px-3 py-2 rounded-lg min-w-fit whitespace-nowrap transition-colors ${activeSection === section.id
                      ? 'bg-blue-50 text-blue-600'
                      : 'hover:bg-gray-100 text-gray-700'
                      }`}
                  >
                    <section.icon className="h-5 w-5 mb-1" />
                    <span className="text-xs">{section.name}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="flex flex-col custom:flex-row gap-4">
              {/* Desktop Sidebar (Vertical) - hidden on mobile */}
              <div className="hidden custom:block w-full custom:w-1/5 ">
                <div className="w-full bg-white sticky top-20 p-4 rounded-lg shadow-sm">
                  <h2 className="text-lg font-semibold mb-4">Profile Sections</h2>
                  <div className="space-y-2">
                    {sections.map((section) => (
                      <div key={section.id}>
                        <button
                          onClick={() => scrollToSection(section.ref, section.id)}
                          className={`w-full flex items-center text-left px-3 py-2 rounded transition ${activeSection === section.id
                            ? 'bg-blue-50 text-blue-600 font-medium'
                            : 'hover:bg-gray-100 text-gray-700'
                            }`}
                        >
                          <section.icon className="h-5 w-5 mr-3" />
                          {section.name}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Main content - full width on mobile, 75% on desktop */}
              <div className="w-full custom:w-4/5 space-y-6">
                {/* <div ref={subscriptionRef}>
                  <CandidateActiveSubscription />
                </div> */}
                <div ref={profileRef}>
                  <CandidateProfile />
                </div>
                <div ref={educationRef}>
                  <EducationshowPage />
                </div>
                <div ref={experienceRef}>
                  <ExperienceShowTesting />
                </div>
                <div ref={certificationRef}>
                  <Certifications />
                </div>
                <div ref={projectsRef}>
                  <Projects />
                </div>
                <div ref={skillsRef}>
                  <ITskills />
                </div>
                <div ref={languageRef}>
                  <Language />
                </div>
                <div ref={jobPrefRef}>
                  <JobPreferences2 />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center text-gray-600 mt-8 text-sm">
            <p>© {new Date().getFullYear()} IndiaHirings.com All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}